export default {
  common: {
    colon: ': ',
    cancel: 'Cancel',
    confirm: 'Confirm',
    back: 'Back',
    noBooking: 'Booking information not found',
    placeholderNote: 'Screen coming soon (awaiting design)'
  },
  views: {
    trainList: {
      vehicleInfo: 'Train Information',
      ticketName: 'Shinkansen Ticket',
      travelDate: 'Travel Date: ',
      route: 'Departure & Arrival: ',
      ticketCount: 'Quantity: ',
      adult: 'Adult',
      child: 'Child',
      trainType: 'Train Type',
      seatClass: 'Seat Type: ',
      preOrderNote:
        '*For bookings more than a month ahead, ticketing starts one month before the travel date. Results can be checked on the home page.',
      selectStation: 'Select Station',
      from: 'From',
      to: 'To',
      selectTrain: 'Select Train',
      select: 'Select',
      book: 'Book',
      seatAvailable: 'Available',
      seatLimited: 'Limited',
      soldOut: 'Sold Out',
      notOnSale: 'Not on sale',
      durationFormat: '{{hours}}h {{minutes}}m',
      noTrains: 'No trains for this time range'
    },
    seat: {
      title: 'Select Seat',
      ticketCount: 'Quantity',
      adult: 'Adult',
      preference: 'Seat Preference',
      window: 'Prefer window',
      aisle: 'Prefer aisle',
      adjacent: 'Prefer adjacent seats',
      next: 'Next'
    },
    confirm: {
      trainConfirm: 'Train Confirmation',
      ticketName: 'Shinkansen Ticket',
      route: 'Departure & Arrival: ',
      travelDate: 'Travel Date: ',
      ticketCount: 'Quantity: ',
      trainType: 'Train Type: ',
      seatClass: 'Seat Type: ',
      preference: 'Seat Preference: ',
      confirmSelect: 'Confirm Selection'
    },
    submitted: {
      title: 'Reservation Submitted',
      thanks:
        'Thank you for your booking. Please return to the home page to check the ticketing result.',
      thanksSub:
        '*Ticketing starts one month before the travel date. Please wait.',
      ticketName: 'Shinkansen Ticket',
      route: 'Departure & Arrival: ',
      travelDate: 'Travel Date: ',
      ticketCount: 'Quantity: ',
      trainType: 'Train Type: ',
      seatClass: 'Seat Type: ',
      preference: 'Seat Preference: ',
      backHome: 'Back to Home',
      noticeTitle: 'Notice',
      notice1:
        'Ticketing is paused during system maintenance from 23:30 to 05:30 (JST) daily. Tickets are issued automatically afterwards, and results can be checked on the home page.',
      notice2:
        'If ticketing fails, the home page ticket will show "Limited". Please tap the "Book Ticket" button at the bottom to try again.'
    }
  }
};
